import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseEquipmentTypesAdapter = getAdapter();

const warehouseEquipmentTypesSlice = createSlice({
  name: 'warehousesLookups',
  initialState: warehouseEquipmentTypesAdapter.getInitialState(),
  reducers: {
    setWarehousesLookups: (state, { payload: { warehousesLookups } }) => {
      warehouseEquipmentTypesAdapter.setAll(state, warehousesLookups);
    },
  },
});

const selectors = warehouseEquipmentTypesAdapter.getSelectors(({ warehousesLookups }) => warehousesLookups);

export const getWarehousesLookups = (state) => selectors.selectAll(state);

export const {
  setWarehousesLookups,
} = warehouseEquipmentTypesSlice.actions;

export default warehouseEquipmentTypesSlice.reducer;